import { useAuth } from "./useAuth";
import { useEntitlementOverride } from "@/lib/entitlementFlip";

/** Returns true only after the entitlement row has confirmed active Pro. */
export const useIsPro = (): boolean => {
  const { isPro, proLoaded } = useAuth();
  const entitlementOverride = useEntitlementOverride();
  return proLoaded && (isPro || entitlementOverride === true);
};